<template>
  <div class="vente-moderne-container">

    <!-- HEADER -->
    <!-- <div class="vente-header d-flex justify-content-between align-items-center mb-4 px-3 py-3">
      <h2 class="mb-0 fw-bold text-primary">
        <i class="fa fa-shopping-cart me-2"></i>
      </h2>
      <div class="date-badge">
        <i class="fa fa-calendar me-1"></i>
        {{getCurrentDateTime()}}
      </div>
    </div> -->

    <Form @submit="addVente" :validation-schema="venteSchema" :keep-values="valuess">
      <div class="row gx-3">

        <!-- ========== COLONNE GAUCHE (formulaire) ========== -->
        <div class="col-lg-9">

          <div class="card vente-card mb-3">
            <div class="card-header vente-card-header">
              <i class="fa fa-info-circle me-2"></i>Nouvelle commande
            </div>
            <div class="card-body p-3">
              <div class="row gx-2">

                <!-- Type Commande -->
                <div class="col-md-3" v-if="typeFacture !== 'Facture proforma'">
                  <div class="form-group mb-2">
                    <label class="d-block text-black">Type Commande <span class="text-danger">*</span></label>
                    <Field name="typeCommande" v-model="typeC" v-slot="{ field }">
                      <Multiselect :options="['Au comptoir', 'Sur commande']" :searchable="true" track-by="label" label="label"
                        v-model="field.value" v-bind="field" placeholder="Sélectionner"
                        @select="showHide(field.value)" />
                    </Field>
                    <ErrorMessage name="groupeTaxe" class="text-danger" />
                  </div>
                </div>

                <!-- Type Facture -->
                <div class="col-md-3">
                  <div class="form-group mb-2">
                    <label class="d-block text-black">Type Facture <span class="text-danger">*</span></label>
                    <Field name="typeFacture" v-model="typeFacture" v-slot="{ field }">
                      <Multiselect :options="['Facture de vente','Facture de vente à l\'exportation','Facture proforma']" :searchable="true"
                        track-by="label" label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner" />
                    </Field>
                    <ErrorMessage name="typeFacture" class="text-danger" />
                  </div>
                </div>

                <!-- Pays d'origine -->
                <div class="col-md-3" v-if="typeFacture === 'Facture de vente à l\'exportation'">
                  <div class="form-group mb-2">
                    <label class="d-block text-black">Pays d'origine <span class="text-danger">*</span></label>
                    <Field name="paysOrigine" v-model="paysOrigine" v-slot="{ field }">
                      <Multiselect :options="getPaysOrigineOptions" :searchable="true" track-by="label" label="label"
                        v-model="field.value" v-bind="field" placeholder="Pays d'origine" />
                    </Field>
                    <ErrorMessage name="paysOrigine" class="text-danger" />
                  </div>
                </div>

                <!-- Lieu de chargement -->
                <div class="col-md-3" v-if="paysOrigine">
                  <div class="form-group mb-2">
                    <label class="d-block text-black">Lieu de chargement</label>
                    <Field v-model="lieuChargement" name="lieuChargement" type="text"
                      class="form-control shadow-none fs-md-15 text-black" placeholder="" />
                  </div>
                </div>

                <!-- Pays de destination -->
                <div class="col-md-3" v-if="typeFacture === 'Facture de vente à l\'exportation'">
                  <div class="form-group mb-2">
                    <label class="d-block text-black">Pays de destination <span class="text-danger">*</span></label>
                    <Field name="paysDestination" v-model="paysDestination" v-slot="{ field }">
                      <Multiselect :options="getPaysDestinationOptions" :searchable="true" track-by="label" label="label"
                        v-model="field.value" v-bind="field" placeholder="Pays de destination" />
                    </Field>
                    <ErrorMessage name="paysDestination" class="text-danger" />
                  </div>
                </div>

                <!-- Lieu de déchargement -->
                <div class="col-md-3" v-if="paysDestination">
                  <div class="form-group mb-2">
                    <label class="d-block text-black">Lieu de déchargement</label>
                    <Field v-model="lieuDechargement" name="lieuDechargement" type="text"
                      class="form-control shadow-none fs-md-15 text-black" placeholder="" />
                  </div>
                </div>

                <!-- Client -->
                <div class="col-md-4">
                  <div class="form-group mb-2">
                    <label class="d-block text-black">
                      Client <span class="text-danger">*</span>
                      <a style="float:right" v-if="!selectedClient" class="btn btn-success me-3 btn-xs b-r-6"
                        data-bs-toggle="modal" data-bs-target="#AddClientModal" @click="toggleAbonne">
                        <i class="fa fa-plus-circle"></i>
                      </a>
                      <button style="float:right" v-if="selectedClient" class="btn btn-success me-3 btn-xs" @click="toggleAbonne">
                        <i class="fa fa-plus-circle"></i> Rechercher un client
                      </button>
                    </label>
                    <Field name="client" v-slot="{ field, handleChange }" v-if="!selectedClient">
                      <Multiselect :options="clientOptions" :searchable="true" track-by="label" label="label"
                        :model-value="clientCharger"
                        @update:model-value="(v) => { clientCharger = v; handleChange(v); }"
                        placeholder="Sélectionner le client" />
                    </Field>
                    <Field name="client" v-model="selectedClientId" v-slot="{ field }" v-else>
                      <Multiselect v-model="field.value" :options="clientsOps" placeholder="Sélectionner un client" />
                    </Field>
                    <ErrorMessage name="client" class="text-danger" />
                  </div>
                </div>

                <!-- Taux AIB -->
                <div class="col-md-2">
                  <div class="form-group mb-2">
                    <label class="d-block text-black fw-semibold">TAUX AIB</label>
                    <Field name="tauxAIB" v-model="valeurAib" v-slot="{ field }">
                      <Multiselect :options="['1', '5']" :searchable="true" track-by="label" label="label"
                        v-model="field.value" v-bind="field" placeholder="Choisir" />
                    </Field>
                    <ErrorMessage name="tauxAIB" class="text-danger" />
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- Card 2 : Ajouter un produit -->
          <div class="card vente-card mb-3">
            <div class="card-header vente-card-header d-flex justify-content-between align-items-center">
              <span class="header-title-only"></span>
              <button class="btn-add-product" type="button"
                :class="{ 'btn-add-product-disabled': isDisable }" :disabled="isDisable"
                @click="addRowProduit()">
                <i class="fa fa-plus-circle me-2"></i>
                {{enModification ? 'Mettre à jour le produit' : 'Ajouter un produit'}}
              </button>
            </div>
            <div class="card-body p-3">

              <div class="row gx-2 mb-3">
                <div class="col-md-5">
                  <label class="d-block text-black">Produit<span class="text-danger">*</span></label>
                  <Multiselect :options="produitOptions" :searchable="true" track-by="label" label="label"
                    v-model="produit.produit" placeholder="Sélectionnez le produit"
                    :disabled="!clientCharger"
                    @select="selectProd(produit.produit, produit)"
                    @open="checkClientBeforeOpenProduit" />
                  <span class="text-warning small" v-if="!clientCharger">
                    <i class="fa fa-info-circle me-1"></i>Veuillez d'abord sélectionner un client
                  </span>
                  <span class="invalid-feedback d-block" v-if="validateRowProduit(produit.produit)">Champ obligatoire</span>
                </div>
                <div class="col-md">
                  <label class="d-block text-black" title="Quantité du produit">Qte<span class="text-danger">*</span></label>
                  <input type="text" v-model.number="produit.qtite"
                    :class="validateRowProduit(produit.qtite) ? 'form-control is-invalid' : 'form-control'"
                    placeholder="Quantité" @keyup="eventProduit" />
                  <span class="invalid-feedback" v-if="validateRowProduit(produit.qtite)">Champ obligatoire</span>
                </div>
                <div class="col-md">
                  <label class="d-block text-black" title="Prix Unitaire">
                    PU<span class="text-danger">*</span>
                    <i class="fa fa-info-circle text-muted ms-1" v-if="produit.prixMin && produit.prixMax"
                      :title="`Prix recommandé: ${produit.prixMin} - ${produit.prixMax}`"
                      style="font-size:12px;cursor:help;"></i>
                  </label>
                  <input type="number" v-model.number="produit.prixTtc"
                    :class="validateRowProduit(produit.prixTtc) ? 'form-control is-invalid' : 'form-control'"
                    placeholder="Prix" @keyup="onPrixManuelChange(); eventProduit()" @blur="validatePrixUnitaire" />
                  <span class="invalid-feedback" v-if="validateRowProduit(produit.prixTtc)">Champ obligatoire</span>
                </div>
                <div class="col-md-3" v-if="moduleGStockActif">
                  <label class="d-block text-black" title="Magasin de stockage">Magasin</label>
                  <Multiselect :options="magasin1Options" :searchable="true" track-by="label" label="label"
                    v-model="produit.magasin" placeholder="Sélectionner" @select="updateStockByMagasin(produit)" />
                  <div class="mt-1">
                    <small class="text-muted">Logique: <strong>{{produit.stockLogique || 0}}</strong></small>
                    <small class="text-muted ms-3">Physique: <strong>{{produit.stockPhysique || 0}}</strong></small>
                  </div>
                  <span class="invalid-feedback d-block" v-if="validateRowProduit(produit.magasin)">Champ obligatoire</span>
                </div>
                <div class="col-auto" v-if="moduleGStockActif">
              <label class="d-block" style="visibility: hidden;">Action</label>
              <button
                type="button"
                class="btn btn-info d-flex align-items-center justify-content-center"
                data-bs-toggle="modal"
                data-bs-target="#AddInfoRemiseModal"
                title="Ajouter remise et taxe"
                style="height: 40px; width: 40px; padding: 0;">
                <i class="fa fa-plus-circle"></i>
              </button>
            </div>
              </div>

              
             <div class="row gx-2 mb-2 px-2 py-1 bg-light border rounded" v-if="produit.produit && produit.qtite > 0">
    <div class="col">
      <label class="text-muted mb-0 fs-12">Prix HT</label>
      <div class="fw-semibold text-dark fs-13">{{ produit.prixHt || 0 }}</div>
    </div>
    <div class="col">
      <label class="text-muted mb-0 fs-12">Montant HT</label>
      <div class="fw-semibold text-dark fs-13">{{ produit.montantHt || 0 }}</div>
    </div>
    <div class="col">
      <label class="text-muted mb-0 fs-12">Remise</label>
      <div class="fw-semibold text-dark fs-13">{{ produit.remise || 0 }}</div>
    </div>
    <div class="col">
      <label class="text-muted mb-0 fs-12">HT après RSE</label>
      <div class="fw-semibold text-dark fs-13">{{ produit.montantHtApresRemise || 0 }}</div>
    </div>
    <div class="col">
      <label class="text-muted mb-0 fs-12">TVA</label>
      <div class="fw-semibold text-dark fs-13">{{ produit.montantTva || 0 }}</div>
    </div>
    <div class="col">
      <label class="text-muted mb-0 fs-12">TTC</label>
      <div class="fw-bold text-dark fs-14">{{ produit.montantTtc || 0 }}</div>
    </div>
  </div>

                <div v-if="prixErrorMessage" class="alert alert-danger py-1 mt-2" role="alert">
                <i class="fa fa-exclamation-triangle me-2"></i>{{prixErrorMessage}}
              </div>

              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade p-10" id="home2-tab-pane" role="tabpanel" tabindex="0">
                  <div class="row">
                    <div class="border border-primary mb-5">
                      <div class="row d-flex align-items-center justify-content-between fw-bold py-2"
                        style="background-color: #0a59a4 !important">
                        <div class="col-md-7">
                          <h3 class="fs-4 text-white">Entête de la facture</h3>
                        </div>
                        <div class="col-md-5">
                          <div class="d-flex float-end">
                            <button class="default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success"
                              type="button" :class="{ 'cursor-not-allowed': isDisableElement }" :disabled="isDisableElement" @click="addRowElement">
                              <i class="fa fa-plus-circle position-relative ms-5 fs-12"></i>
                              Ajouter une entête
                            </button>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="row d-flex align-items-center justify-content-between mt-10">
                          <div class="col-md-3"><label class="d-block text-black fw-semibold">Titre <span class="text-danger">*</span></label></div>
                          <div class="col-md-3"><label class="d-block text-black fw-semibold">Description</label></div>
                          <div class="col-md-2"><label class="d-block text-black fw-semibold">Taille police <span class="text-danger">*</span></label></div>
                          <div class="col-md-3"><label class="d-block text-black fw-semibold">Alignement <span class="text-danger">*</span></label></div>
                          <div class="col-md-1"><label class="d-block text-black fw-semibold">Action</label></div>
                        </div>
                        <hr class="mt-0" />
                        <div class="row mb-5" v-for="(element, index) in elements" :key="index">
                          <div class="col-md-3 mb-5">
                            <Field name="titre" type="text" v-model="element.titre"
                              class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le titre" />
                            <div class="invalid-feedback" v-if="validateRowElement(element.titre)">Le titre est obligatoire.</div>
                          </div>
                          <div class="col-md-3 mb-5">
                            <Field name="description" type="text" v-model="element.description"
                              class="form-control shadow-none fs-md-15 text-black" placeholder="" />
                          </div>
                          <div class="col-md-2 mb-5">
                            <Field name="taillePolice" type="number" v-model="element.taillePolice"
                              class="form-control shadow-none fs-md-15 text-black" placeholder="" />
                          </div>
                          <div class="col-md-2 mb-5">
                            <Multiselect :options="['Centre', 'Gauche', 'Droite']" :searchable="true" track-by="label"
                              label="label" v-model="element.alignement" placeholder="" />
                          </div>
                          <div class="col-md-1 mb-5">
                            <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button" @click="removeRowElement(index)">
                              <i class="icofont icofont-ui-delete"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- Card 3 : Produits de la commande (tableau) -->
          <div class="card vente-card mb-3" v-if="produits.length > 0">
            <div class="card-body p-3">
              <h5 class="mb-3" style="color: #111827;">
                <i class="fa fa-list me-2"></i>Produits sélectionnés 
                <span class="badge rounded-pill" style="background-color: #e5e7eb; color: #6b7280; font-size: 0.875rem;">{{produits.length}}</span>
              </h5>
              <div class="table-responsive">
                <table class="table table-fixed text-nowrap align-middle mb-0 table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" class="produit info" title="Produit sélectionné">Produit</th>
                      <th scope="col" class="quantite" title="Quantité du produit">Qte</th>
                      <th scope="col" class="prix-unitaire" title="Prix Unitaire">PU</th>
                      <th scope="col" title="Prix Hors Taxe">Prix HT</th>
                      <th scope="col" title="Montant Hors Taxe">MT HT</th>
                      <th scope="col" class="taxe" title="Taxe Spécifique">Taxe S.</th>
                      <th scope="col" class="type-rse" title="Type de Remise, Solde ou Escompte">Type RSE</th>
                      <th scope="col" class="vente-rse" title="Vente normale ou Remise, Solde, Escompte">Vente/RSE</th>
                      <th scope="col" title="Montant de la Remise">MT Remise</th>
                      <th scope="col" title="Montant Hors Taxe Après Remise, Solde, Escompte">MT HT Ap RSE</th>
                      <th scope="col" title="Montant de la Taxe sur la Valeur Ajoutée">MT TVA</th>
                      <th scope="col" class="text pe-0" title="Montant Toutes Taxes Comprises">MT TTC</th>
                      <th scope="col" class="magasin" v-if="moduleGStockActif" title="Magasin de stockage">Magasin</th>
                      <th scope="col" class="actions pe-0" title="Actions disponibles sur cette ligne">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(produit, index) in produits" :key="index">
                      <td class="produit-col">
                        <div class="fw-semibold">{{produit.libelleProduit}}</div>
                      
                      </td>
                      <td class="quantite-col">{{produit.qtite}}</td>
                      <td class="prix-unitaire-col">{{produit.prixTtc}}</td>
                      <td class="taxe-col">{{produit.prixHt}}</td>
                      <td class="taxe-col">{{produit.montantHt}}</td>
                      <td class="taxe-col">{{produit.taxeSpecifique}}</td>
                      <td class="type-rse-col">{{produit.typeRemise}}</td>
                      <td class="vente-rse-col">{{produit.valeurRemise}}</td>
                      <td class="taxe-col">{{produit.remise}}</td>
                      <td class="taxe-col">{{produit.montantHtApresRemise}}</td>
                      <td class="taxe-col">{{produit.montantTva}}</td>
                      <td class="taxe-col">{{produit.montantTtc}}</td>
                      <td class="magasin-col" v-if="moduleGStockActif">{{getMagasinLabel(produit.magasin)}}</td>
                      <td class="actions-col pe-0">
                        <div class="button-container d-flex gap-1">
                          <button type="button" class="btn btn-sm"
                            style="background-color: #00bcd4; color: white; border: none; width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
                            @click="showDetails(produit)"
                            data-bs-toggle="modal"
                            data-bs-target="#stockDetailsModal"
                            title="Voir détails">
                            <i class="fa fa-eye"></i>
                          </button>

                          <button type="button" class="btn btn-sm"
                        style="background-color: #9e9e9e; color: white; border: none; width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
                        @click="editProduit(index)"
                        title="Modifier">
                        <i class="fa fa-edit"></i>
                      </button>

                      <button type="button" class="btn btn-sm"
                        style="background-color: #f56565; color: white; border: none; width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center;"
                        @click="removeRowProduit(index)"
                        title="Supprimer">
                        <i class="fa fa-trash"></i>
                      </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card vente-card mb-3" v-else>
            <div class="card-body p-3">
              <h5 class="mb-3" style="color: #111827;">
                <i class="fa fa-list me-2"></i>Produits sélectionnés 
                <span class="badge rounded-pill" style="background-color: #e5e7eb; color: #6b7280; font-size: 0.875rem;">{{produits.length}}</span>
              </h5>
              <div class="table-responsive text-center">
                <h5 class="mb-0" style="color: #111827; font-size: 14px;">
                <i class="fa fa-info-circle me-2"></i>Vos Produits sélectionnés s'afficheront ici
              </h5>
              </div>
            </div>
          </div>

        </div>
        <!-- FIN COLONNE GAUCHE -->

        <div class="col-lg-3">
          <div class="card vente-card recapitulatif-card sticky-lg-top" style="top: 80px;">

            <div class="card-header vente-card-header">
              <i class="fa fa-calculator me-2"></i>Récapitulatif
            </div>
            <div class="card-body p-3">

              <!-- Date commande (champ caché pour vee-validate) -->
              <Field name="dateCommande" :readonly="true" :value="getCurrentDateTime()" type="datetime-local"
                class="form-control shadow-none fs-md-15 text-black d-none" placeholder="" />

              <div class="recap-table mb-3">
                <Field v-model="totalsomme" name="montantHT" type="hidden" />
                <Field v-model="totalsommeremise" name="montantHTRSE" type="hidden" />
                <Field v-model="totaltva" name="montantTVA" type="hidden" />
                <Field v-model="totalaib" name="montantAIB" type="hidden" />
                <Field v-model="totalts" name="montantTS" type="hidden" />
                <Field v-model="totalttc" name="montantTTC" type="hidden" />

                <!-- Affichage style ticket de caisse -->
                <div class="recap-row">
                  <span class="recap-label">Montant HT</span>
                  <!-- <span class="recap-dots"></span> -->
                  <span class="recap-value">{{ totalsomme }}</span>
                </div>
                <div class="recap-row">
                  <span class="recap-label">Montant HT RSE</span>
                  <!-- <span class="recap-dots"></span> -->
                  <span class="recap-value">{{ totalsommeremise }}</span>
                </div>
                <div class="recap-row">
                  <span class="recap-label">Montant TVA</span>
                  <!-- <span class="recap-dots"></span> -->
                  <span class="recap-value">{{ totaltva }}</span>
                </div>
                <div class="recap-row">
                  <span class="recap-label">Montant AIB</span>
                  <!-- <span class="recap-dots"></span> -->
                  <span class="recap-value">{{ totalaib }}</span>
                </div>
                <div class="recap-row">
                  <span class="recap-label">Taxe S.</span>
                  <!-- <span class="recap-dots"></span> -->
                  <span class="recap-value">{{ totalts }}</span>
                </div>
                <div class="recap-row recap-ttc">
                  <span class="recap-label fw-bold">TOTAL TTC</span>
                  <!-- <span class="recap-dots"></span> -->
                  <span class="recap-value fw-bold">{{ totalttc }}</span>
                </div>
              </div>

              <hr />

              <div v-if="showC && moduleBilletageActif">
                <h6 class="text-black mb-2"><i class="fa fa-money-bill me-1"></i>Paiement</h6>
                <div class="form-group mb-2">
                  <label class="d-block text-black">Montant Reçu <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <Field name="montantReçu" type="text" v-model.number="montantReçu"
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Montant reçu" readonly />
                    <button type="button" class="btn btn-primary btn-md btn-calculator"
                      :data-bs-toggle="clientCharger && produits.length > 0 && totalttc > 0 ? 'modal' : ''"
                      :data-bs-target="clientCharger && produits.length > 0 && totalttc > 0 ? '#billetagePaiementModal' : ''"
                      @click="checkBeforeOpenBilletage"
                      title="Ouvrir le billetage"
                      :disabled="!clientCharger || produits.length === 0 || totalttc <= 0"
                      style="animation:none !important;transform:none !important;transition:none !important;">
                      <i class="fa fa-calculator"></i>
                    </button>
                  </div>
                  <small class="text-warning d-block mt-1" v-if="clientCharger && produits.length > 0 && totalttc > 0 && moduleBilletageActif && showC && !montantReçu">
                    <i class="fa fa-info-circle me-1"></i>Veuillez cliquer sur la calculatrice pour régler
                  </small>
                  <ErrorMessage name="montantReçu" class="text-danger" />
                  <small v-if="reliquatNonRendu > 0" class="text-warning d-block mt-1">
                    <i class="fa fa-exclamation-triangle"></i> Reliquat non rendu: {{reliquatNonRendu}} Fcfa
                  </small>
                </div>
                <div class="form-group mb-2">
                  <label class="d-block text-black">Reliquat</label>
                  <Field name="reliquat" v-model="reliquatAffiche" :readonly="true" type="text"
                    class="form-control shadow-none fs-md-15 text-black" :class="{
                      'text-success': reliquatAffiche > 0,
                      'text-danger': reliquatAffiche < 0
                    }" />
                </div>
                <hr />
              </div>

              <!-- Format d'impression -->
              <div class="form-group mb-3">
                <label class="d-block text-black"><i class="fa fa-print me-1"></i>Format d'impression</label>
                <Field name="formatImpression" v-model="formatImpression" v-slot="{ field }">
                  <Multiselect :options="['A4', 'A5', 'A6', 'T1', 'T2']" :searchable="true" v-model="field.value"
                    v-bind="field" placeholder="Format impression" />
                </Field>
                <ErrorMessage name="formatImpression" class="text-danger" />
              </div>

              <hr />

              <!-- Boutons d'action -->
              <div class="action-buttons-group">
                <button 
                  type="submit" 
                  class="btn-modern btn-modern-primary"
                  :disabled="isDisable || (moduleBilletageActif && showC && typeFacture !== 'Facture proforma' && (!montantTotalEncaissement || montantTotalEncaissement < totalttc))"
                  :class="{ 'btn-modern-disabled': isDisable || (moduleBilletageActif && showC && typeFacture !== 'Facture proforma' && (!montantTotalEncaissement || montantTotalEncaissement < totalttc)) }">
                  <i class="fa fa-save"></i>
                  Enregistrer
                </button>

                <button 
                  type="button" 
                  class="btn-modern btn-modern-secondary"
                  :disabled="isDisable || isGeneratingPdf || (moduleBilletageActif && showC && typeFacture !== 'Facture proforma' && (!montantTotalEncaissement || montantTotalEncaissement < totalttc))"
                  :class="{ 'btn-modern-disabled': isDisable || isGeneratingPdf || (moduleBilletageActif && showC && typeFacture !== 'Facture proforma' && (!montantTotalEncaissement || montantTotalEncaissement < totalttc)) }"
                  @click="handleSaveAndPrint">
                  <i v-if="!isGeneratingPdf" class="fa fa-print"></i>
                  <i v-else class="fa fa-spinner fa-spin"></i>
                  {{isGeneratingPdf ? 'Génération...' : 'Enregistrer et imprimer'}}
                </button>

                <router-link 
                  to="/ventes/liste-ventes" 
                  class="btn-modern btn-modern-danger">
                  <i class="fa fa-times"></i>
                  Annuler
                </router-link>
              </div>

            </div>
          </div>
        </div>
        <!-- FIN COLONNE DROITE -->

      </div>
    </Form>

    <!-- ======== MODALS ======== -->

    <!-- Modal Détails produit -->
    <div class="modal fade" id="stockDetailsModal" tabindex="-1" aria-labelledby="stockDetailsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" style="display:flex;align-items:center;min-height:calc(100vh - 1rem);margin:0.5rem auto;">
        <div class="modal-content">
          <div class="modal-header">
            <h5>Détails du produit</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-12">
                <p class="fw-bold mb-1">Produit :</p>
                <p>{{selectedProduit?.libelleProduit || 'Non défini'}}</p>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3"><p class="fw-bold mb-1">Quantité :</p><p>{{selectedProduit?.qtite || 'Non défini'}}</p></div>
              <div class="col-md-3"><p class="fw-bold mb-1">Prix unitaire :</p><p>{{selectedProduit?.prixTtc || 'Non défini'}}</p></div>
              <div class="col-md-3"><p class="fw-bold mb-1">Prix HT :</p><p>{{selectedProduit?.prixHt || 'Non défini'}}</p></div>
              <div class="col-md-3"><p class="fw-bold mb-1">Montant HT :</p><p>{{selectedProduit?.montantHt || 'Non défini'}}</p></div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3"><p class="fw-bold mb-1">Taxe S. :</p><p>{{selectedProduit?.taxeSpecifique || 'Non défini'}}</p></div>
              <div class="col-md-3"><p class="fw-bold mb-1">Type RSE :</p><p>{{selectedProduit?.typeRemise || 'Non défini'}}</p></div>
              <div class="col-md-3"><p class="fw-bold mb-1">Valeur RSE :</p><p>{{selectedProduit?.valeurRemise || 'Non défini'}}</p></div>
              <div class="col-md-3"><p class="fw-bold mb-1">MT Remise :</p><p>{{selectedProduit?.remise || 'Non défini'}}</p></div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3"><p class="fw-bold mb-1">MT. HT Ap Rse :</p><p>{{selectedProduit?.montantHtApresRemise || 'Non défini'}}</p></div>
              <div class="col-md-3"><p class="fw-bold mb-1">MT. TVA :</p><p>{{selectedProduit?.montantTva || 'Non défini'}}</p></div>
              <div class="col-md-3"><p class="fw-bold mb-1">MT. TTC :</p><p>{{selectedProduit?.montantTtc || 'Non défini'}}</p></div>
              <div class="col-md-3"><p class="fw-bold mb-1">Magasin :</p><p>{{getMagasinLabel(selectedProduit?.magasin)}}</p></div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Billetage -->
    <BilletageModal 
      v-if="moduleBilletageActif"
      :billetage-list="billetageList"
      :billetage-sortie-list="billetageSortieList"
      :totalttc="totalttc"
      :billetage-error="billetageError"
      @validate="handleBilletageValidation"
      @update:montantRecu="(val) => montantReçu = val"
    />

    <!-- Modal Info Remise -->
    <AddInfoRemiseModal 
      :type-remise="produit.typeRemise"
      :valeur-remise="produit.valeurRemise"
      :taxe-specifique="produit.taxeSpecifique"
      @update="handleInfoRemiseUpdate"
    />

    <!-- Modal Ajout client -->
    <AddClientModal @getclient="getClient" />

  </div>
</template>


<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive, computed } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import { Vente } from "@/models/Vente";
import * as Yup from "yup";
import axios from "axios";
import Multiselect from "@vueform/multiselect";
import AddClientModal from "./AddClientModal.vue";
import BilletageModal from "./BilletageModal.vue";
import AddInfoRemiseModal from "./AddInfoRemiseModal.vue";
import { ProduitSelect } from "@/models/Produit";
import { error, success, warning } from "@/utils/utils";
import { client } from "@/core/data/dashboards";
import { Modal } from 'bootstrap';
import paysData from "@/data/countries-FR.json";


interface BilletageForm {
  libelle: string;
  qteBillet: number;
  montant: number;
  monnaie: number;
  valueAct: number;
}
export default defineComponent({
  name: "AddVente",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    AddClientModal,
    BilletageModal,
    AddInfoRemiseModal,
  },
  setup: () => {
    // Déclarations des variables utilisées dans le schema
    const moduleGStockActif = ref(true);
    const moduleBilletageActif = ref(true);
    const showC = ref(true);
    
    const venteSchema = Yup.object().shape({
      typeCommande: Yup.string().when('typeFacture', {
        is: (val: string) => val !== 'Facture proforma',
        then: (schema) => schema.required("Le type de commande est obligatoire"),
        otherwise: (schema) => schema.notRequired()
      }),
      typeFacture: Yup.string().required("Le type de facture est obligatoire"),
      tauxAIB: Yup.string().notRequired(),
      montantReçu: Yup.string().when([], (value, schema) => {
        return (moduleBilletageActif.value && showC.value)
          ? schema.required("Le montant est obligatoire")
          : schema.notRequired();
      }),
      formatImpression: Yup.string().required("Le format d'impression est obligatoire"),
      paysOrigine: Yup.string().when('typeFacture', {
        is: (val: string) => val === 'Facture de vente à l\'exportation',
        then: (schema) => schema.required("Le pays d'origine est obligatoire"),
        otherwise: (schema) => schema.notRequired()
      }),
      paysDestination: Yup.string().when('typeFacture', {
        is: (val: string) => val === 'Facture de vente à l\'exportation',
        then: (schema) => schema.required("Le pays de destination est obligatoire"),
        otherwise: (schema) => schema.notRequired()
      }),
    });

    const venteForm = ref<Vente | null>(null);
    const router = useRouter();
    const magasin1Options = ref([]);
    const produitOptions = ref([]);
    const produitsss = ref(null);
    const clientOptions = ref([]);
    const paysOptions = ref([]);
    const paysOrigine = ref(null);
    const paysDestination = ref(null);
    const produitShow = ref(null);
    const selectedClient = ref(false);
    const isSaving = ref(false);
    const billetageForm = ref<InstanceType<typeof Form> | null>(null);
    const billetageList = reactive<BilletageForm[]>([]);
    const billetageSortieList = reactive<BilletageForm[]>([]);
    const monnaieList = ref<any[]>([]);
    const montantTotalEncaissement = ref<number | null>(null);
    const montantTotalSortie = ref<number | null>(null);
    const reliquatNonRendu = ref<number>(0);
    const billetageError = ref<string>('');
    const caisseActive = ref<boolean>(true);
    const reliquatAffiche = ref(0);



    const enModification = ref(false);
    const modificationIndex = ref(null);
    const toggleAbonne = () => {
      selectedClient.value = !selectedClient.value;
    };
    const selectedClientId = ref(0);
    const clientsOps = ref<Array<{ value: any; label: string }>>([]);
    const clientCharger = ref(null);
    const montantReçu = ref(null);

    const totalsomme = ref(0.0);
    const totalsommeremise = ref(0.0);
    const totaltva = ref(0.0);
    const totalts = ref(0.0);
    const totalttc = ref(0.0);
    const totalaib = ref(0.0);
    const valeurAib = ref(0);
    // const clientId = 3;
    const selectedProduit = ref(null);
    const formatImpression = ref("A4");
    const produits = ref<Array<ProduitSelect>>([]);
    const typeFacture = ref('Facture de vente');
    const isGeneratingPdf = ref(false);
    const reliquat = ref(0);
    const lieuChargement = ref('');
    const lieuDechargement = ref('');
    const prixManuelModifie = ref(false);
    const selectedClientLibelle = ref('');



    const getClient = async (values: {
      id: any;
      nomClient: string;
      prenomClient: string;
      raisonSociale: string;
    }) => {
      try {
        selectedClientId.value = values.id;
        const data = {
          value: values.id,
          label: values?.nomClient
            ? values?.nomClient + "" + values?.prenomClient
            : "" + values?.raisonSociale,
        };
        clientsOps.value = [...clientsOps.value, data];
        clientCharger.value = values.id;
        return clientsOps.value;
      } catch (error) {
        // Gérer l'erreur ici
      }
    };




       const fetchMagasin1 = async () => {
      try {
        const response = await ApiService.get("/all/all/magasins");
        const magasin1sData = response.data.data;
        magasin1Options.value = magasin1sData.map((magasin) => ({
          value: magasin.id + "|" + magasin.nomMagasin,
          label: magasin.code + ' - ' + magasin.nomMagasin + ' du ' + magasin.magasin.nomMagasin,
        }));
      } catch (error) {
        //
      }
    };

    

    const showDetails = (produit) => {
      selectedProduit.value = produit;
      console.log("produittt", selectedProduit);
    };

    const fetchProduits = async () => {
      try {
        const response = await axios.get("/all/produitconditionnements");
        const produitsData = response.data.data;
        produitsss.value = produitsData;
        produitOptions.value = produitsData.map((produitconditionnements) => ({
          value:
            produitconditionnements.id + "|" +
            // `${produitconditionnements.produit?.refProd} : ${produitconditionnements.produit?.codeProduit} ` +
            `${produitconditionnements.produit?.nomProd} [ ${produitconditionnements.conditionnement?.libelle} ]` + "|" +
            produitconditionnements.prixVenteHt + "|" +
            produitconditionnements.prixVenteTtc,

          label: `${produitconditionnements.produit?.refProd
            ? produitconditionnements.produit.refProd
            : produitconditionnements.produit?.codeProduit
            } : ${produitconditionnements.produit?.nomProd} [ ${produitconditionnements.conditionnement?.libelle} ]`,
          stockLogique: produitconditionnements.qteStockCondLogique || 0,
          stockPhysique: produitconditionnements.qteStockCond || 0


        }));

      } catch (error) {
        //
      }
    };


    const getPrixProduitCondiTypeClient = async (produitConditionnementId, clientId) => {
      console.log("recupp", produitConditionnementId, clientId);

      try {
        const response = await ApiService.get(`/prixproduitcondtypeclient/${produitConditionnementId}/${clientId}`);
        console.log("responnnnse", response);
        const donnePrix = response.data;
        return donnePrix;
      } catch (error) {

        error("Le prix produitContionnement type client n'\a pas pu être recupere")
        return null;
      }
    }

    const getMagasinLabel = (magasiId) => {
      const magasin = magasin1Options.value.find((m) => m.value === magasiId);
      return magasin ? magasin.label : 'Non defini';
    }

    const prixInitial = ref<number>(0)

    const checkClientBeforeOpenProduit = () => {
      if (!clientCharger.value) {
        warning("Veuillez d'abord sélectionner un client avant de choisir un produit");
        return false;
      }
      return true;
    };

    const checkBeforeOpenBilletage = () => {
      if (!clientCharger.value) {
        warning("Veuillez d'abord sélectionner un client");
        return false;
      }
      if (produits.value.length === 0) {
        warning("Veuillez ajouter au moins un produit avant d'ouvrir le billetage");
        return false;
      }
      if (totalttc.value <= 0) {
        warning("Le total de la vente doit être supérieur à zéro");
        return false;
      }
      return true;
    };

    const updateStockByMagasin = async (produitForm) => {
      if (!produitForm.produit || !produitForm.magasin) {
        produitForm.stockLogique = 0;
        produitForm.stockPhysique = 0;
        return;
      }

      const produitId = produitForm.produit.split("|")[0];
      const magasinId = typeof produitForm.magasin === 'object' ? produitForm.magasin.value : produitForm.magasin;

      try {
        const response = await ApiService.get(`/stock/produit/${produitId}/magasin/${magasinId}`);
        const stockData = response.data.data;

        produitForm.stockLogique = Number(stockData.qtiteLogique || 0);
        produitForm.stockPhysique = Number(stockData.qtite || 0);
      } catch (error) {
        console.error("Erreur lors de la récupération du stock:", error);
        produitForm.stockLogique = 0;
        produitForm.stockPhysique = 0;
      }
    };

    const selectProd = async (selectedProduit, produitForm) => {

      const dataprice = await getPrixProduitCondiTypeClient(selectedProduit.split("|")[0], clientCharger.value)
      console.log(selectedProduit, "selectedProduit");

      if (!dataprice || !dataprice.data || dataprice.data.prixTTC === null || dataprice.data.prixTTC === undefined) {
        warning("Aucun prix défini pour ce produit et ce client. Veuillez définir un prix avant de continuer.");
        produitForm.produit = null;
        return;
      }

      const taux = dataprice.data?.produitConditionnement?.produit?.groupeTaxes?.taux || 0;
      produitForm.taxe = taux === 0 ? 0 : 1;
      produitForm.regimeTPS = taux === 0 ? 'E' : 'N';
      produitForm.exonere = taux === 0;
      const codeGroupe = dataprice.data?.produitConditionnement?.produit?.groupeTaxes?.code || '';
      produitForm.groupeTaxeCode = codeGroupe;
      console.log("produiitttslectionnn", produitForm.groupeTaxeCode);
      produitForm.groupeTaxeProduit = dataprice.data?.produitConditionnement?.produit?.groupeTaxes?.code + '|' + dataprice.data?.produitConditionnement?.produit?.groupeTaxes?.taux + '|' + dataprice.data?.produitConditionnement?.produit?.groupeTaxes?.libelle;

      produitForm.qtite = 1;
      produitForm.prixTtc = Number(dataprice.data.prixTTC);
      produitForm.prixHt = Number(dataprice.data.prixHT);
      prixInitial.value = Number(dataprice.data.prixTTC);
      produitForm.prixInitial = Number(dataprice.data.prixTTC);
      prixManuelModifie.value = false;  
      produitForm.prixMin = Number(dataprice.data.prixMin || 0);
      produitForm.prixMax = Number(dataprice.data.prixMax || 0);
      produitForm.libelleProduit = selectedProduit.split("|")[1];
      produitForm.montantHt = Number(produitForm.prixHt);
      produitForm.montantTva = Number(produitForm.prixTtc - produitForm.prixHt);
      produitForm.montantTtc = Number(produitForm.prixTtc);
      produitForm.montantTs = 0.0;
      produitForm.montantHtApresRemise = Number(produitForm.prixHt);
      produitForm.stockLogique = 0;
      produitForm.stockPhysique = 0;

      // Sélectionner automatiquement le premier magasin s'il y en a
      if (magasin1Options.value && magasin1Options.value.length > 0) {
        produitForm.magasin = magasin1Options.value[0].value;
        // Mettre à jour le stock pour ce magasin
        await updateStockByMagasin(produitForm);
      }
    };

    const fetchClient = async () => {
      try {
        const response = await ApiService.get(
          `/clients/${selectedClientId.value}`
        );
        const clientData = response.data.data.data;
        console.log("clientData", clientData);
        clientsOps.value = clientData.map((client) => ({
          value: client.id,
          label: `${client?.nomClient
            ? client?.nomClient + "" + client?.prenomClient
            : client?.raisonSociale
            }`,
        }));
      } catch (error) {
        //
      }
    };

    const fetchClients = async () => {
      try {
        const response = await ApiService.get(`/all/clientsAndCreate`);
        console.log("responsssseee", response);
        const clientData = response.data.data;
        console.log("clientData", clientData);
        clientOptions.value = clientData.map((client) => ({
          value: client.id,
          label: `${client?.nomClient
            ? client?.nomClient + " " + client?.prenomClient
            : client?.raisonSociale
            }`,
        }));

       if(clientOptions.value) {
          const defaultClient = clientOptions.value.find(c => c.label === 'CLIENT CASH');
          // if (defaultClient) {
          //   clientCharger.value = defaultClient;

          //   console.log('defaultClient trouvé:', defaultClient);
          //   console.log('clientCharger après assignation:', clientCharger.value);
          //   console.log('Tous les clients:', clientOptions.value);
          // }
          if (!clientCharger.value) {
            const defaultClient = clientOptions.value.find(c => c.label === 'CLIENT CASH');
            if (defaultClient) {
              clientCharger.value = defaultClient.value; // l'id (2), pas l'objet
            }
          }
        }

        console.log("clientCharger final:", clientCharger.value, typeof clientCharger.value);
      } catch (error) {
        //
      }
    };

    const fetchPays = () => {
      paysOptions.value = Object.entries(paysData).map(([code, nom]) => ({
        value: `${nom.trim()} [ ${code} ]`,
        label: nom.trim(),
      }));
    };




    const getPaysOrigineOptions = computed(() => {
      return paysOptions.value.filter(
        (option) => option.value !== paysDestination.value
      );
    });

    const getPaysDestinationOptions = computed(() => {
      return paysOptions.value.filter(
        (option) => option.value !== paysOrigine.value
      );
    });




    const fetchMonnaies = async () => {
      try {
        const response = await ApiService.get("/all/monnaies");
        console.log("vallllll", response);
        const monnaiesData = response.data.data.data;
        monnaieList.value = monnaiesData;

        billetageList.splice(0, billetageList.length);
        billetageSortieList.splice(0, billetageSortieList.length);

        monnaiesData.forEach((monnaie: any) => {
          billetageList.push({
            libelle: monnaie.libelle,
            qteBillet: 0,
            montant: 0,
            monnaie: monnaie.valeur,
            valueAct: monnaie.valeur,
          });

          billetageSortieList.push({
            libelle: monnaie.libelle,
            qteBillet: 0,
            montant: 0,
            monnaie: monnaie.valeur,
            valueAct: monnaie.valeur,
          });
        });
      } catch ({ response }) {
        error(response?.data?.message || "Impossible de charger les monnaies");
      }
    };

    const reliquatCalcule = computed(() => {
      if (!montantTotalEncaissement.value || !totalttc.value) {
        return 0;
      }
      return montantTotalEncaissement.value - totalttc.value;
    });

    watch(reliquatCalcule, (newVal) => {
      reliquatAffiche.value = newVal;
    });

    const billetageValide = ref(false);

    const handleBilletageValidation = async (data: any) => {
      billetageError.value = '';

      // Vérifier si un reliquat doit être rendu
      if (data.reliquatNonRendu > 0 && data.montantTotalSortie === 0) {
        billetageError.value = `Reliquat non rendu au client: ${data.reliquatNonRendu} Fcfa`;
        reliquatNonRendu.value = data.reliquatNonRendu;
      }

      // Vérifier la disponibilité des billets en caisse pour le reliquat
      if (data.montantTotalSortie > 0) {
        const billetsSortie = data.billetageSortieList
          .filter(b => b.qteBillet > 0)
          .map(b => ({
            monnaie: b.valueAct,
            qteBillet: b.qteBillet
          }));

        if (billetsSortie.length > 0) {
          try {
            const response = await ApiService.post('/caisse/verifier-billets', {
              billets: billetsSortie
            });

            if (!response.data.success) {
              billetageError.value = response.data.message;
              return;
            }
          } catch (err) {
            billetageError.value = "Impossible de vérifier les billets en caisse";
            return;
          }
        }
      }

      // Mettre à jour les valeurs
      montantTotalEncaissement.value = data.montantTotalEncaissement;
      montantTotalSortie.value = data.montantTotalSortie;
      reliquatNonRendu.value = data.reliquatNonRendu;
      montantReçu.value = data.montantTotalEncaissement;
      
      billetageValide.value = true;
      success("Billetage validé avec succès");
    };

    const handleInfoRemiseUpdate = (data: any) => {
      produit.typeRemise = data.typeRemise;
      produit.valeurRemise = data.valeurRemise;
      produit.taxeSpecifique = data.taxeSpecifique;
      eventProduit();
    };

    const resetBilletage = () => {
      billetageList.forEach(b => {
        b.qteBillet = 0;
        b.montant = 0;
      });
      billetageSortieList.forEach(b => {
        b.qteBillet = 0;
        b.montant = 0;
      });
      montantTotalEncaissement.value = 0;
      montantTotalSortie.value = 0;
      reliquatNonRendu.value = 0;
      billetageError.value = '';
      montantReçu.value = null;
    };


    onMounted(() => {
      fetchMagasin1();
      fetchProduits();
      fetchClients();
      fetchMonnaies();
      fetchPays();
      // chargerVenteEnCours(); // COMMENTÉ : Désactive la restauration automatique depuis sessionStorage

      // Charger la config MODULE-G-STOCK et MODULE-G-BILLETAGE
      ApiService.get("/all/configuration").then((response) => {
        const configs = response.data.data;
        const stockConfig = configs.find((c: any) => c.cle === "MODULE-G-STOCK");
        if (stockConfig) {
          moduleGStockActif.value = stockConfig.valeur;
        }
        const billetageConfig = configs.find((c: any) => c.cle === "MODULE-G-BILLETAGE");
        if (billetageConfig) {
          moduleBilletageActif.value = billetageConfig.valeur;
        }
      }).catch(() => {
        // En cas d'erreur, on garde true par défaut
      });
    });

    const addVente = async (values, { resetForm }, shouldNormalize = false) => {
        const clientId = values.client || clientCharger.value;

      if (!clientId) {
        error("Veuillez sélectionner un client");
        return null;
      }

      const isProforma = typeFacture.value === 'Facture proforma';

      if (isProforma) {
        shouldNormalize = false;
      }

      if (moduleBilletageActif.value && typeC.value === "Au comptoir" && !isProforma) {
        if (!montantTotalEncaissement.value || montantTotalEncaissement.value === 0) {
          error("Veuillez renseigner le billetage en cliquant sur le bouton calculatrice");
          return null;
        }

        if (montantTotalEncaissement.value < totalttc.value) {
          error("Le montant encaissé est insuffisant");
          return null;
        }
      }

      if (produits.value.length === 0) {
        error("Veuillez ajouter au moins un produit");
        return null;
      }

      const validProduits = produits.value.filter((produit) => produit.produit && typeof produit.produit === "string");

      if (validProduits.length === 0) {
        error("Aucun produit valide n'a été sélectionné");
        return null;
      }

      const payload = {
        commande: {
          montantHT: values.montantHT,
          montantHTRSE: values.montantHTRSE,
          montantTVA: values.montantTVA,
          montantTS: values.montantTS,
          exonere: totalExonere.value,
          regimeTPS: totalRegimeTPS.value,
          montantAIB: values.montantAIB,
          montantTTC: values.montantTTC,
          montantReserveF: totalReserveF.value,
          dateCommande: values.dateCommande || getCurrentDate(),
          typeCommande: isProforma ? null : values.typeCommande,
          typeFacture: values.typeFacture,
          paysOrigine: values.paysOrigine,
          paysDestination: values.paysDestination,
          lieuDechargement: values.lieuDechargement,
          lieuChargement: values.lieuChargement,
          tauxAIB: values.tauxAIB,
          montantReçu: isProforma ? "0" : (values.montantReçu || "0"),
          clientId: clientId,
          societeId: 1,
          formatImpression: values.formatImpression,

        },
        produits: produits.value.map((produit) => ({
          produit: produit.produit.split("|")[0],
          typeRemise: produit.typeRemise,
          libelleProduit: produit.libelleProduit,
          qtite: produit.qtite,
          prixTtc: produit.prixTtc,
          prixHt: produit.prixHt,
          prixInitial: produit.prixInitial,
          montantHt: produit.montantHt,
          montantTva: produit.montantTva,
          montantTtc: produit.montantTtc,
          montantTs: produit.montantTs,
          taxeSpecifique: produit.taxeSpecifique,
          valeurRemise: produit.valeurRemise,
          montantHtApresRemise: produit.montantHtApresRemise,
          remise: produit.remise,
          magasin: produit.magasin,
          taxe: produit.taxe,
           groupeTaxeCode: produit.groupeTaxeCode,
           groupeTaxe: produit.groupeTaxeProduit
        })),
        elements: elements.map((element) => ({
          titre: element.titre,
          description: element.description,
          taillePolice: element.taillePolice,
          alignement: element.alignement,
        })),
        normaliser: shouldNormalize,
        billetage: typeC.value === "Au comptoir" && !isProforma ? {
          encaissement: billetageList.map(b => ({
            libelle: b.libelle,
            qteBillet: b.qteBillet,
            montant: b.montant,
            monnaie: b.monnaie,
            valueAct: b.valueAct
          })),
          sortie: billetageSortieList.map(b => ({
            libelle: b.libelle,
            qteBillet: b.qteBillet,
            montant: b.montant,
            monnaie: b.monnaie,
            valueAct: b.valueAct
          })),
          montantTotalEncaissement: montantTotalEncaissement.value,
          montantTotalSortie: montantTotalSortie.value,
          reliquatNonRendu: reliquatNonRendu.value
        } : null
      };

      console.log("Payload avec billetage:", payload);

      try {
        const response = await ApiService.post("/commandeClients", payload);

        if (response.data.code === 201) {
          isSaving.value = true;
          success(response.data.message);
          nettoyerVenteEnCours();
          resetForm();
          resetFormData();
          setTimeout(() => {
            isSaving.value = false;
          }, 100);
          router.push({ name: "ListeVente" });
          return response;
        }

        const errorMsg = response.data.message || "Erreur lors de l'enregistrement";
        error(errorMsg);
        return null;

      } catch (err) {
        console.error('Erreur complète:', err);

        let errorMessage = "Erreur inattendue";
        let isStockError = false;

        if (err.response) {
          errorMessage = err.response.data?.message
            || err.response.data?.errors
            || err.response.statusText
            || "Erreur lors de l'opération";

          const errorLower = errorMessage.toLowerCase();
          isStockError = errorLower.includes('stock insuffisant')
            || errorLower.includes('stock')
            || err.response.data?.errors === "Stock insuffisant";
        } else if (err.message) {
          errorMessage = err.message;
        }

        if (isStockError) {
          warning(errorMessage);
        } else {
          error(errorMessage);
        }

        return null;
      }
    };


    const handleSaveAndPrint = async () => {
      const loadingHtml = `
    <html>
      <head><title>Génération facture...</title></head>
      <body style="font-family: Arial; text-align: center; padding: 50px; background: #f8f9fa;">
        <div style="max-width: 400px; margin: 0 auto; padding: 30px; background: white; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
          <div style="width: 50px; height: 50px; border: 4px solid #e3e3e3; border-top: 4px solid #007bff; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 20px;"></div>
          <h3 style="color: #333; margin-bottom: 10px;">Enregistrement et génération...</h3>
          <p style="color: #666; margin: 0;">Veuillez patienter quelques instants</p>
        </div>
        <style>
          @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        </style>
      </body>
    </html>
  `;

      const newWindow = window.open('', '_blank');
      if (newWindow) {
        newWindow.document.write(loadingHtml);
        newWindow.document.close();
      }

      isGeneratingPdf.value = true;

      try {
        if (!clientCharger.value) {
          error('Veuillez sélectionner un client');
          if (newWindow && !newWindow.closed) {
            newWindow.close();
          }
          return;
        }

        if (produits.value.length === 0) {
          error('Veuillez ajouter au moins un produit');
          if (newWindow && !newWindow.closed) {
            newWindow.close();
          }
          return;
        }

        const isProforma = typeFacture.value === 'Facture proforma';

        // Validation du billetage pour vente au comptoir
        if (moduleBilletageActif.value && typeC.value === "Au comptoir" && !isProforma) {
          if (!montantTotalEncaissement.value || montantTotalEncaissement.value === 0) {
            error("Veuillez renseigner le billetage en cliquant sur le bouton calculatrice");
            if (newWindow && !newWindow.closed) {
              newWindow.close();
            }
            return;
          }

          if (montantTotalEncaissement.value < totalttc.value) {
            error("Le montant encaissé est insuffisant");
            if (newWindow && !newWindow.closed) {
              newWindow.close();
            }
            return;
          }
        }

        const formData = {
          montantHT: totalsomme.value,
          montantHTRSE: totalsommeremise.value,
          montantTVA: totaltva.value,
          montantTS: totalts.value,
          montantAIB: totalaib.value,
          montantTTC: totalttc.value,
          exonere: totalExonere.value,
          regimeTPS: totalRegimeTPS.value,
          montantReserveF: totalReserveF.value,
          dateCommande: getCurrentDate(),
          typeCommande: isProforma ? null : typeC.value,
          typeFacture: typeFacture.value,
          tauxAIB: valeurAib.value,
          montantReçu: isProforma ? "0" : montantReçu.value,
          client: clientCharger.value,
          formatImpression: formatImpression.value,
          paysOrigine: paysOrigine.value,
          paysDestination: paysDestination.value,
          lieuChargement: lieuChargement.value,
          lieuDechargement: lieuDechargement.value,

        };

        const response = await addVente(formData, { resetForm: () => { } }, !isProforma);

        if (!response) {
          if (newWindow && !newWindow.closed) {
            newWindow.close();
          }
          return;
        }

        if (!response.data?.data?.facture?.id) {
          error('Erreur lors de l\'enregistrement de la facture');
          if (newWindow && !newWindow.closed) {
            newWindow.close();
          }
          return;
        }

        const factureId = response.data.data.facture.id;

        const pdfResponse = await ApiService.get(`/commande/facture/${factureId}?format=${formatImpression.value}`, "", {
          responseType: "blob",
          timeout: 60000
        });

        console.log("PDF généré:", pdfResponse);

        const blob = new Blob([pdfResponse.data], { type: 'application/pdf' });
        console.log("Taille du blob:", blob.size, "bytes");

        if (blob.size === 0) {
          throw new Error("PDF vide reçu du serveur");
        }

        const blobUrl = window.URL.createObjectURL(blob);

        if (newWindow && !newWindow.closed) {
          newWindow.location.href = blobUrl;
          success("Facture enregistrée et ouverte avec succès");
        } else {
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = `facture-${factureId}-${formatImpression.value}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          success("Facture enregistrée et téléchargée avec succès");
        }

        resetFormData();
        router.push({ name: "ListeVente" });

      } catch (err: any) {
        console.error('Erreur complète:', err);

        if (newWindow && !newWindow.closed) {
          newWindow.close();
        }

        let errorMessage = "Erreur lors de la génération du PDF";

        if (err.message === 'Timeout') {
          errorMessage = "La génération de la facture prend trop de temps. Réessayez.";
        } else if (err.code === 'ECONNABORTED') {
          errorMessage = "Connexion interrompue. Vérifiez votre connexion internet.";
        } else if (err.message) {
          errorMessage = err.message;
        }

        error(errorMessage);
      } finally {
        isGeneratingPdf.value = false;
      }
    };

    watch(typeFacture, (newValue) => {
      if (newValue === 'Facture proforma') {
        typeC.value = null;
        showC.value = false;
        montantReçu.value = null;
        reliquat.value = 0;
        resetBilletage();
      } else {
        if (!typeC.value) {
          typeC.value = "Au comptoir";
        }
        showC.value = typeC.value === "Au comptoir";
      }
    });

    const resetFormData = () => {
      produits.value = [];
      clientCharger.value = null;
      selectedClientId.value = 0;
      montantReçu.value = null;
      totalsomme.value = 0.0;
      totalsommeremise.value = 0.0;
      totaltva.value = 0.0;
      totalts.value = 0.0;
      totalttc.value = 0.0;
      totalaib.value = 0.0;
      valeurAib.value = 0;
      typeC.value = "Au comptoir";
      typeFacture.value = "Facture de vente";
      formatImpression.value = "A4";
      produit.produit = "";
      produit.qtite = 0.0;
      produit.prixInitial = 0.0
      produit.prixTtc = 0.0;
      produit.prixHt = 0.0;
      produit.taxeSpecifique = 0.0;
      produit.typeRemise = "";
      produit.valeurRemise = 0.0;
      produit.montantHt = 0.0;
      produit.montantTva = 0.0;
      produit.montantTtc = 0.0;
      produit.montantTs = 0.0;
      produit.montantHtApresRemise = 0.0;
      produit.libelleProduit = "";
      produit.groupeTaxeProduit = "";
      produit.carton = 0.0;
      produit.piece = 0.0;
      produit.stock = 0.0;
      produit.remise = 0.0;
      produit.restAliv = 0.0;
      produit.taxe = 1;
      paysOrigine.value = null;
      produit.regimeTPS = 'N';
      produit.exonere = false;


      // Reset du billetage
      resetBilletage();

      // Nettoyer le sessionStorage
      nettoyerVenteEnCours();
    };


    const sauvegarderVenteEnCours = () => {
      try {
        const venteData = {
          clientCharger: clientCharger.value,
          selectedClientId: selectedClientId.value,
          produits: produits.value,
          typeC: typeC.value,
          typeFacture: typeFacture.value,
          valeurAib: valeurAib.value,
          montantReçu: montantReçu.value,
          formatImpression: formatImpression.value,
          elements: elements,
          billetageEncaissement: billetageList,
          billetageSortie: billetageSortieList,
          montantTotalEncaissement: montantTotalEncaissement.value,
          montantTotalSortie: montantTotalSortie.value,
          reliquatNonRendu: reliquatNonRendu.value,
          timestamp: new Date().getTime()
        };
        sessionStorage.setItem('venteEnCours', JSON.stringify(venteData));
      } catch (error) {
        console.error('Erreur lors de la sauvegarde de la vente:', error);
      }
    };

    const chargerVenteEnCours = () => {
      try {
        const savedData = sessionStorage.getItem('venteEnCours');
        if (savedData) {
          const venteData = JSON.parse(savedData);

          clientCharger.value = venteData.clientCharger;
          selectedClientId.value = venteData.selectedClientId;
          produits.value = venteData.produits || [];
          typeC.value = venteData.typeC || "Au comptoir";
          typeFacture.value = venteData.typeFacture || "Facture de vente";
          valeurAib.value = venteData.valeurAib || 0;
          montantReçu.value = venteData.montantReçu;
          formatImpression.value = venteData.formatImpression || "A4";

          if (venteData.elements && venteData.elements.length > 0) {
            elements.splice(0, elements.length, ...venteData.elements);
          }

          // Restaurer le billetage
          if (venteData.billetageEncaissement && venteData.billetageEncaissement.length > 0) {
            billetageList.splice(0, billetageList.length, ...venteData.billetageEncaissement);
          }
          if (venteData.billetageSortie && venteData.billetageSortie.length > 0) {
            billetageSortieList.splice(0, billetageSortieList.length, ...venteData.billetageSortie);
          }
          montantTotalEncaissement.value = venteData.montantTotalEncaissement || 0;
          montantTotalSortie.value = venteData.montantTotalSortie || 0;
          reliquatNonRendu.value = venteData.reliquatNonRendu || 0;

          calculeDestotaux();

          console.log('Vente restaurée depuis sessionStorage');
        }
      } catch (error) {
        console.error('Erreur lors du chargement de la vente:', error);
        sessionStorage.removeItem('venteEnCours');
      }
    };

    const nettoyerVenteEnCours = () => {
      try {
        sessionStorage.removeItem('venteEnCours');
        console.log('SessionStorage nettoyé');
      } catch (error) {
        console.error('Erreur lors du nettoyage du sessionStorage:', error);
      }
    };


    const showDetail = (prod) => {
      produitShow.value = prod;
    };
    const typeC = ref("Au comptoir");

    function showHide(test) {
      console.log("test", test);
      if (test == "Sur commande") {
        showC.value = false;
        console.log("ff", showC.value);
      } else {
        showC.value = true;
        console.log("el", showC.value);
      }
    }

    const isDisable = ref(true);
    const prixErrorMessage = ref('');

    const produit = reactive(
      {
        commande_clit_id: "",
        magasin: "",
        produit: "",
        prixInitial: 0.0,
        qtite: 0.0,
        prixTtc: 0.0,
        prixHt: 0.0,
        prixMin: 0.0,
        prixMax: 0.0,
        taxeSpecifique: 0.0,
        typeRemise: '',
        valeurRemise: 0.0,
        montantHt: 0.0,
        montantTva: 0.0,
        montantTtc: 0.0,
        montantTs: 0.0,
        montantHtApresRemise: 0.0,
        libelleProduit: "",
        groupeTaxeProduit: "",
        carton: 0.0,
        piece: 0.0,
        stock: 0.0,
        remise: 0.0,
        restAliv: 0.0,
        taxe: 1,
        stockLogique: 0.0,
        stockPhysique: 0.0,
        regimeTPS: 'N',
        exonere: false,
        groupeTaxeCode: '',
      },
    );

    const editProduit = (index) => {
      enModification.value = true;
      modificationIndex.value = index;
      const selectedProduit = produits.value[index];

      Object.assign(produit, {
        commande_clit_id: selectedProduit.commande_clit_id,
        magasin: selectedProduit.magasin,
        produit: selectedProduit.produit,
        qtite: selectedProduit.qtite,
        prixTtc: selectedProduit.prixTtc,
        prixHt: selectedProduit.prixHt,
        prixMin: (selectedProduit as any)?.prixMin || 0,
        prixMax: (selectedProduit as any)?.prixMax || 0,
        prixInitial: (selectedProduit as any)?.prixInitial || 0,
        taxeSpecifique: selectedProduit.taxeSpecifique,
        typeRemise: selectedProduit.typeRemise,
        valeurRemise: selectedProduit.valeurRemise,
        montantHt: selectedProduit.montantHt,
        montantTva: selectedProduit.montantTva,
        montantTtc: selectedProduit.montantTtc,
        montantTs: selectedProduit.montantTs,
        montantHtApresRemise: selectedProduit.montantHtApresRemise,
        libelleProduit: selectedProduit.libelleProduit,
        groupeTaxeProduit: selectedProduit.groupeTaxeProduit,
        carton: selectedProduit.carton,
        piece: selectedProduit.piece,
        stock: selectedProduit.stock,
        remise: selectedProduit.remise,
        restAliv: selectedProduit.restAliv,
        taxe: selectedProduit.taxe,
        groupeTaxeCode: selectedProduit.groupeTaxeCode
      });
    }

    async function addRowProduit() {

      if (moduleGStockActif.value && !produit.magasin) {
        error("Veuillez selectionner le magasin ");
        return;
      }

      if (!validatePrixUnitaire()) {
        return;
      }

      if (enModification.value) {

        produits.value[modificationIndex.value] = {
          ...produit,
          prixMin: produit.prixMin,
          prixMax: produit.prixMax
        } as any;
        enModification.value = false;
        modificationIndex.value = null;
      } else {

        const tproduit = {
          ...produit,
          prixMin: produit.prixMin,
          prixMax: produit.prixMax,
          prixInitial: produit.prixInitial
        } as any;
        produits.value.push(tproduit);
        console.log("noussommmmeiccc", produits.value, produit);
      }
      
      // Réinitialiser le flag après l'ajout du produit
      prixManuelModifie.value = false;
      
      produit.commande_clit_id = "",
        produit.magasin = null,
        produit.produit = null,
        produit.qtite = 0.0,
        produit.prixTtc = 0.0,
        produit.prixHt = 0.0,
        produit.taxeSpecifique = 0.0,
        produit.typeRemise = '',
        produit.valeurRemise = 0.0,
        produit.montantHt = 0.0,
        produit.montantTva = 0.0,
        produit.montantTtc = 0.0,
        produit.montantTs = 0.0,
        produit.montantHtApresRemise = 0.0,
        produit.libelleProduit = "",
        produit.groupeTaxeProduit = "",
        produit.carton = 0.0,
        produit.piece = 0.0,
        produit.stock = 0.0,
        produit.remise = 0.0,
        produit.restAliv = 0.0;
      produit.prixMin = 0.0;
      produit.prixMax = 0.0;
      produit.taxe = 1;
      produit.stockLogique = 0.0;
      produit.stockPhysique = 0.0;
      produit.prixInitial = 0.0
      produit.groupeTaxeCode = '';
      calculeDestotaux();


    }

    const removeRowProduit = (index) => {
      produits.value.splice(index, 1);
      calculeDestotaux();
    };

    watch(typeC, (newValue, oldValue) => {
      if (newValue === "Au comptoir") {
        showC.value = true;
      } else {
        showC.value = false;
        if (oldValue === "Au comptoir") {
          montantReçu.value = null;
          resetBilletage();

          if (montantTotalEncaissement.value > 0) {
            warning("Le billetage a été réinitialisé car vous êtes passé en mode 'Sur commande'");
          }
        }
      }
    });

    const validateRowProduit = (value) => {
      return !value || value <= 0;
    };

    // watch(
    //   produit,
    //   (newValue) => {
    //     isDisable.value = validateRowProduit(newValue.produit);
    //     // newValue.some(
    //     //   (produit) =>
    //     //     validateRowProduit(newValue.produit) ||
    //     //     validateRowProduit(newValue.qtite) ||
    //     //     validateRowProduit(newValue.prixTtc)
    //     // );
    //   },
    //   { deep: true }
    // );

    watch(
      [produit, produits],
      ([newProduit, newProduits]) => {
        if (newProduits.length > 0) {
          isDisable.value = false;
        } else {
          isDisable.value = validateRowProduit(newProduit.produit) ||
            validateRowProduit(newProduit.qtite) ||
            validateRowProduit(newProduit.prixTtc);
        }
      },
      { deep: true }
    );


    watch(clientCharger, (newValue, oldValue) => {
      if (oldValue !== null && newValue !== oldValue) {
        if (produits.value.length > 0) {
          const confirm = window.confirm(
            "Changer de client réinitialisera tous les produits. Continuer ?"
          );
          if (confirm) {
            produits.value = [];
            produit.produit = null;
            produit.qtite = 0;
            produit.prixTtc = 0;
            produit.prixHt = 0;
            produit.magasin = null;
            calculeDestotaux();
            resetBilletage();
          } else {
            clientCharger.value = oldValue;
          }
        }
      }
    });

    watch(valeurAib, () => {
      calculeDestotaux();
    });

    const isDisableElement = ref(true);

    const elements = reactive([
      {
        titre: "",
        description: "",
        taillePolice: 0,
        alignement: "",
      },
    ]);

    const addRowElement = () => {
      elements.push({
        titre: "",
        description: "",
        taillePolice: 0,
        alignement: "",
      });
    };

    const removeRowElement = (index) => {
      if (elements.length > 1) elements.splice(index, 1);
    };

    const validateRowElement = (value) => {
      return !value || value <= 0;
    };

    watch(
      elements,
      (newValue) => {
        isDisableElement.value = newValue.some(
          (element) =>
            validateRowElement(element.titre) ||
            validateRowElement(element.taillePolice) ||
            validateRowElement(element.alignement)
        );
      },
      { deep: true }
    );

    watch(
      [clientCharger, produits, typeC, typeFacture, valeurAib, montantReçu, formatImpression, elements],
      () => {
        if (!isSaving.value) {
          sauvegarderVenteEnCours();
        }
      },
      { deep: true }
    );

    const valuess = ref();
    const totalReserveF = ref(0);
    const totalExonere = ref(0);
    const totalRegimeTPS = ref(0);

    const getCurrentDateTime = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      const hours = String(today.getHours()).padStart(2, "0");
      const minutes = String(today.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    };

    //calcule des totaux
    var calculeDestotaux = () => {
      totalsomme.value = 0.0;
      totalsommeremise.value = 0.0;
      totaltva.value = 0.0;
      totalts.value = 0.0;
      totalttc.value = 0.0;
      totalaib.value = 0.0;
      totalReserveF.value = 0.0;
      totalExonere.value = 0.0;
      totalRegimeTPS.value = 0.0;

      produits.value.forEach(produi => {



        if (produi.groupeTaxeCode == 'A') {
          totalExonere.value += Number(produi.montantTtc);
          totalttc.value +=   Number(produi.montantTtc);
        }

        if (produi.groupeTaxeCode == 'B') {
          let ts_d_ht = 0;
          let tva_d = 0;
          if (produi.taxeSpecifique > 0) {
            ts_d_ht = produi.taxeSpecifique / 1.18
          } 
          totalsomme.value += Number(produi.montantHt);
          totalsommeremise.value += Number(produi.montantHtApresRemise);
          tva_d = Number((produi.prixTtc / 1.18) * 0.18 * produi.qtite) + (ts_d_ht * 0.18);
          totalts.value += ts_d_ht;
          totaltva.value += tva_d;
          totalttc.value +=  produi.montantHtApresRemise + tva_d + ts_d_ht;
        }

        if (produi.groupeTaxeCode == 'C') {
          totalsommeremise.value += Number(produi.montantHtApresRemise)
          totalsomme.value += Number(produi.montantHt);
          totalttc.value +=  Number(produi.montantHt);
        }

        if (produi.groupeTaxeCode == 'D') {
          let ts_d_ht = 0;
          let tva_d = 0;
          totalsomme.value += Number(produi.montantHtApresRemise);
          if (produi.taxeSpecifique > 0) {
            ts_d_ht = produi.taxeSpecifique / 1.18;
          } 
          
          tva_d = Number((produi.prixTtc / 1.18) * 0.18 * produi.qtite) + (ts_d_ht * 0.18);
          totalts.value += ts_d_ht;
          totaltva.value += tva_d;
          totalttc.value +=  produi.montantHtApresRemise +  ts_d_ht + tva_d;
        }
        // if (produi.groupeTaxeCode == 'E') {
        //   // totalsommeremise.value += Number(produi.montantHtApresRemise)
        //   // totalsomme.value += Number(produi.montantHt);
        //   totalRegimeTPS.value += Number(produi.montantHtApresRemise);
        //    totalts.value += produi.taxeSpecifique;
        //    totalttc.value += totalRegimeTPS.value + totalts.value;
        // }
        if (produi.groupeTaxeCode == 'E') {
          const tsLigne = Number(produi.taxeSpecifique) || 0;
          const ttcLigne = Number(produi.montantHtApresRemise) + tsLigne;
          totalRegimeTPS.value += ttcLigne; 
          totalts.value += tsLigne;
          totalttc.value += ttcLigne;      
        }
        if (produi.groupeTaxeCode == 'F') {
          totalReserveF.value += Number(produi.montantHtApresRemise);
          totalttc.value += totalReserveF.value;
        }

        // if (produi.montantTtc > 0) {
        //   totalttc.value += Number(produi.montantTtc);
        // }
        // console.log("jestrouvveeee", produi.taxeSpecifique);
        // if (produi.taxeSpecifique > 0) {
        //   if (produi.taxe != 0) {
        //     totalts.value += parseInt((Number(produi.taxeSpecifique) / 1.18).toFixed(0))
        //   } else {
        //     totalts.value += Number(produi.taxeSpecifique);
        //     totaltva.value += produi.taxeSpecifique - totalts.value;
        //     console.log("retourneeeeeee", produi.taxeSpecifique - totalts.value, produi.taxeSpecifique);
        //   }
        // }



      });

      if (valeurAib.value && valeurAib.value != 0) {
        const tauxAib = parseFloat(String(valeurAib.value).replace('%', ''));

        if (!isNaN(tauxAib) && tauxAib > 0) {
          totalaib.value = ((totalsommeremise.value + totalExonere.value + totalts.value) * tauxAib) / 100;
        }
      }
      
      totaltva.value = parseFloat(totaltva.value.toFixed(0));
      totalsomme.value = parseFloat(totalsomme.value.toFixed(0));
      totalsommeremise.value = parseFloat(totalsommeremise.value.toFixed(0));
      totalts.value = parseFloat(totalts.value.toFixed(0));
      totalaib.value = parseFloat(totalaib.value.toFixed(0));
      totalttc.value = parseFloat(totalttc.value.toFixed(0)) + totalaib.value;



    }

    const validatePrixUnitaire = () => {
      prixErrorMessage.value = '';

      if (!produit.prixHt || !produit.prixMin || !produit.prixMax) {
        return true;
      }

      const prix = parseFloat(String(produit.prixHt));
      const min = parseFloat(String(produit.prixMin));
      const max = parseFloat(String(produit.prixMax));

      if (prix < min || prix > max) {
        prixErrorMessage.value = `Le prix doit être entre ${min} et ${max}`;
        return false;
      }

      return true;
    };

      const onPrixManuelChange = () => {
        prixManuelModifie.value = true;
        produit.prixInitial = produit.prixTtc; 
        console.log("Prix modifié manuellement, nouvelle base:", produit.prixInitial);
      };

    const eventProduit = () => {

      if (!validatePrixUnitaire()) {
        return;
      }

      produit.qtite = Number(produit.qtite) || 0;
      // produit.prixTtc = Number(produit.prixTtc) || 0;
      // produit.prixHt = produit.prixTtc * 0.82 || 0;
      produit.valeurRemise = Number(produit.valeurRemise) || 0;
      produit.taxeSpecifique = Number(produit.taxeSpecifique) || 0;

         if (produit.groupeTaxeCode === 'B' || produit.groupeTaxeCode === 'D') {
           produit.prixHt = parseFloat((produit.prixInitial / 1.18).toFixed(0));
            } else {
              produit.prixHt = produit.prixInitial;
            }
  //   if (produit.groupeTaxeCode === 'B' || produit.groupeTaxeCode === 'D') {
  //   if (produit.prixTtc !== produit.prixInitial) {
  //     produit.prixHt = parseFloat((produit.prixTtc / 1.18).toFixed(2));
  //   }
  //   // garder le prixHt du backend
  // }


      if (produit.prixTtc && produit.qtite) {
        let remiseUnitaire = 0;
        let prixremise = produit.prixHt;

        if (produit.valeurRemise) {
          if (produit.typeRemise == '%' && produit.valeurRemise != 0) {
            remiseUnitaire = (produit.prixHt * produit.valeurRemise) / 100;
          } else if (produit.typeRemise == 'MT' && produit.valeurRemise != 0) {
            remiseUnitaire = produit.valeurRemise;
          }

          prixremise = produit.prixHt - remiseUnitaire;
        }

        if (produit.prixMin && produit.prixMax && remiseUnitaire > 0) {
          // console.log("groupeTaxeCode:", produit.groupeTaxeCode);
          // console.log("prixTtc (prix unitaire):", produit.prixTtc);
          // console.log("prixHt:", produit.prixHt);
          // console.log("prixInitial:", produit.prixInitial);
          // console.log("exonere:", produit.exonere);
          // console.log("prixMin:", produit.prixMin);
          // console.log("prixMax:", produit.prixMax);
          // console.log("remiseUnitaire:", remiseUnitaire);
          // console.log("prixTtcApresRemise:", produit.prixTtc - remiseUnitaire);
          // console.log("typeRemise:", produit.typeRemise);
          // console.log("valeurRemise:", produit.valeurRemise);
          const prixTtcApresRemise = produit.prixTtc - remiseUnitaire;

          if (prixTtcApresRemise < produit.prixMin) {
            warning(`La remise est trop élevée ! Le prix après remise (${prixTtcApresRemise.toFixed(0)} FCFA) est inférieur au prix minimum autorisé (${produit.prixMin} FCFA).`);

            produit.valeurRemise = 0;
            remiseUnitaire = 0;
            prixremise = produit.prixHt;
            produit.remise = 0;

            return;
          }
        }


     if (remiseUnitaire > 0) {
      if (produit.typeRemise == '%') {
        produit.prixTtc = produit.prixInitial - (produit.prixInitial * produit.valeurRemise / 100);
      } else if (produit.typeRemise == 'MT') {
        produit.prixTtc = produit.prixInitial - remiseUnitaire;
      }
    } else {
      produit.prixTtc = produit.prixInitial;
    }


        // if (remiseUnitaire > 0) {
        //   if (produit.typeRemise == '%') {
        //     produit.prixTtc = produit.prixTtc - (produit.prixTtc * produit.valeurRemise / 100);
        //   } else if (produit.typeRemise == 'MT') {
        //     produit.prixTtc = produit.prixTtc - remiseUnitaire;
        //   }
        // }

        let ts = produit.taxeSpecifique || 0;
        let ts_ht = 0;
        ts = isNaN(ts) ? 0 : ts;

        if (!isNaN(ts) && ts > 0) {
          ts_ht = (produit.taxe != 0) ? (ts / 1.18) : ts;
        }


        produit.montantHt = produit.prixHt * produit.qtite;
        produit.remise = remiseUnitaire * produit.qtite;
        // produit.montantTs = ts;
        produit.montantTs = parseInt(ts_ht.toFixed(0));

        if (produit.groupeTaxeCode === 'B' || produit.groupeTaxeCode === 'D') {
          const htApresRemise = (produit.prixHt - remiseUnitaire) * produit.qtite;
          console.log("prixxxxxht",htApresRemise);

          produit.montantHtApresRemise = parseInt((htApresRemise).toFixed(0));
          console.log("montanHtttApre",produit.montantHtApresRemise);

          // const baseTva = htApresRemise + produit.montantTs;  
          // produit.montantTva = parseInt((baseTva * 0.18).toFixed(0));
          // produit.montantTtc = parseInt((baseTva * 1.18).toFixed(0));

          // const baseTva = htApresRemise + ts;         
          produit.montantTva = parseInt((produit.montantHtApresRemise * 0.18).toFixed(0));
          produit.montantTtc = parseInt((produit.montantHtApresRemise * 1.18 + ts).toFixed(0));
           console.log("montantttttttttTTccc",produit.montantTtc);

        } else {
          const htApresRemise = (produit.prixTtc - remiseUnitaire) * produit.qtite;
          produit.montantHtApresRemise = parseInt(htApresRemise.toFixed(0));
          produit.montantTva = 0;
          // produit.montantTtc = parseInt((htApresRemise).toFixed(0));
          produit.montantTtc = parseInt((htApresRemise + ts).toFixed(0));
        }

        // produit.montantTtc = parseInt((produit.montantTtc + ts).toFixed(0));
        // produit.montantTs = ts * produit.qtite;
      }
    }
    return {
      showDetails,
      totalsomme,
      totalsommeremise,
      totaltva,
      totalts,
      totalttc,
      totalaib,
      valeurAib,
      venteSchema,
      addVente,
      montantReçu,
      venteForm,
      magasin1Options,
      produits,
      produit,
      eventProduit,
      removeRowProduit,
      removeRowElement,
      addRowProduit,
      addRowElement,
      validateRowProduit,
      validateRowElement,
      getPrixProduitCondiTypeClient,
      valuess,
      isDisable,
      isDisableElement,
      getCurrentDateTime,
      getCurrentDate,
      produitOptions,
      showDetail,
      produitsss,
      elements,
      showHide,
      showC,
      typeC,
      produitShow,
      clientOptions,
      toggleAbonne,
      clientsOps,
      clientCharger,
      selectedClientId,
      selectedClient,
      getClient,
      fetchClient,
      handleSaveAndPrint,
      selectProd,
      checkClientBeforeOpenProduit,
      checkBeforeOpenBilletage,
      selectedProduit,
      formatImpression,
      typeFacture,
      enModification,
      modificationIndex,
      editProduit,
      getMagasinLabel,
      isGeneratingPdf,
      updateStockByMagasin,
      reliquat,
      prixErrorMessage,
      // Billetage
      billetageList,
      billetageSortieList,
      montantTotalEncaissement,
      montantTotalSortie,
      reliquatCalcule,
      reliquatNonRendu,
      billetageError,
      caisseActive,
      handleBilletageValidation,
      handleInfoRemiseUpdate,
      resetBilletage,
      billetageValide,
      reliquatAffiche, paysOptions,
      paysOrigine, paysDestination, getPaysOrigineOptions,
      getPaysDestinationOptions, lieuChargement, lieuDechargement,
      moduleGStockActif,
      moduleBilletageActif, onPrixManuelChange, validatePrixUnitaire
    };
  }
});

</script>

<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

.info {
  min-width: 300px
}

input[readonly] {
  background-color: #f0f0f0;
}


.table-responsive {
  overflow-x: auto;
}

.table thead th,

.compact-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  height: 32px;
}

.compact-error {
  font-size: 0.75rem;
  margin-top: 0.125rem;
}

.container-tight {
  padding-left: 0;
  padding-right: 0;
}

.modal-xl {
  max-width: 1200px;
}

.table tbody td {
  white-space: nowrap;
}

.produit-col,
.quantite-col,
.prix-unitaire-col,
.taxe-col,
.type-rse-col,
.vente-rse-col,
.magasin-col {
  min-width: 150px;
}


.actions-col {
  width: 120px;
  position: sticky;
  right: 0;
  background-color: white;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
}

/* Pour le header de la colonne Actions */
.table thead th.actions {
  position: sticky;
  right: 0;
  background-color: white;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
}

.form-control {
  width: 100%;
}

label {
  margin-bottom: 0.2rem;
}

.produit-col {
  white-space: normal !important;
  word-wrap: break-word;
  max-width: 170px;
}

/* ===== DESIGN MODERNE 2 COLONNES - COULEURS EXACTES ===== */
.vente-moderne-container {
  padding: 20px;
  background-color: #f5f7f9;
  min-height: 100vh;
}

.vente-header {
  background: #ffffff;
  border-radius: 0;
  color: #111827;
  box-shadow: none;
  border: none;
}

.vente-header h2 {
  color: #111827 !important;
  font-weight: 700;
  font-size: 1.75rem;
}

.date-badge {
  background: #ffffff;
  color: #6b7280;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 400;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.vente-card {
  border: none;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  background: #ffffff;
}

.vente-card-header {
  background: #ffffff;
  color: #111827;
  font-weight: 600;
  font-size: 1rem;
  padding: 16px 20px;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #e5e7eb;
}

.recapitulatif-card {
  border: none;
  background: #ffffff;
}

.recap-table {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.recap-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.recap-label {
  min-width: 140px;
  font-size: 0.875rem;
  color: #6b7280;
  white-space: nowrap;
  font-weight: 400;
}

.recap-field {
  max-width: 140px;
  text-align: right;
  background-color: transparent;
  border: none;
  color: #111827;
  font-weight: 600;
  font-size: 1rem;
}

.recap-ttc .recap-label {
  font-size: 1rem;
  color: #6b7280;
  font-weight: 600;
}

.recap-ttc-field {
  background-color: transparent;
  border: none;
  font-size: 1.5rem;
  color: #111827;
  font-weight: 700;
}

@media (max-width: 991px) {
  .sticky-lg-top {
    position: relative !important;
  }
}

/* ===== STYLES DES BOUTONS D'ACTION (Style image de référence) ===== */
.action-buttons-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}

/* Style pour le header sans texte à gauche */
.header-title-only {
  display: none;
}

/* Bouton "Ajouter un produit" modernisé */
.btn-add-product {
  background-color: var(--theme-deafult);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-add-product:hover:not(.btn-add-product-disabled) {
  background-color: color-mix(in srgb, var(--theme-deafult) 85%, black);
}

.btn-add-product:active:not(.btn-add-product-disabled) {
  background-color: color-mix(in srgb, var(--theme-deafult) 70%, black);
}

.btn-add-product-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.btn-add-product i {
  font-size: 0.875rem;
}

.btn-modern {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 24px;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  color: white;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
  box-shadow: none;
  width: 100%;
}

.btn-modern i {
  font-size: 1rem;
}

/* Bouton Enregistrer - Violet/Indigo */
.btn-modern-primary {
  background-color: var(--theme-deafult);
  color: white;
}

.btn-modern-primary:hover:not(.btn-modern-disabled) {
  background-color: color-mix(in srgb, var(--theme-deafult) 85%, black);
  color: white;
}

/* Bouton Enregistrer et imprimer - Blanc avec bordure et icône noire */
.btn-modern-secondary {
  background-color: #ffffff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  font-weight: 500;
}

.btn-modern-secondary:hover:not(.btn-modern-disabled) {
  background-color: #f9fafb;
  border-color: #9ca3af;
  color: #1f2937;
}

.btn-modern-secondary i {
  color: #1f2937;
}

/* Bouton Annuler - Texte rouge sans fond */
.btn-modern-danger {
  background-color: transparent;
  color: #dc2626;
  border: none;
  font-weight: 600;
}

.btn-modern-danger:hover:not(.btn-modern-disabled) {
  background-color: #fef2f2;
  color: #b91c1c;
}

.btn-modern-danger i {
  color: #dc2626;
}

.btn-modern-danger:hover:not(.btn-modern-disabled) i {
  color: #b91c1c;
}

/* État désactivé */
.btn-modern-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.btn-modern-disabled:hover {
  background-color: inherit !important;
  border-color: inherit !important;
  color: inherit !important;
}

/* Animation pour le spinner */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.fa-spinner.fa-spin {
  animation: spin 1s linear infinite;
}

/* Style ticket de caisse pour le récapitulatif */
.recap-table {
  width: 100%;
  background-color: #f9fafb;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.recap-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 4px 0;
}

.recap-label {
  white-space: nowrap;
  color: #374151;
  font-size: 0.95rem;
}

.recap-dots {
  flex: 1;
  border-bottom: 1px dashed #9ca3af;
  transform: translateY(-3px);
}

.recap-value {
  white-space: nowrap;
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: #111827;
  font-weight: 500;
  min-width: 80px;
}

.recap-ttc {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 2px solid #374151;
}

.recap-ttc .recap-label {
  font-size: 1.05rem;
  color: #111827;
}

.recap-ttc .recap-dots {
  border-bottom-style: solid;
  border-bottom-color: #374151;
}

.recap-ttc .recap-value {
  font-size: 1.1rem;
  color: var(--theme-deafult);
}

/* Responsive */
@media (max-width: 768px) {
  .btn-modern {
    padding: 12px 20px;
    font-size: 0.95rem;
  }

  .action-buttons-group {
    gap: 10px;
  }
  
  .btn-add-product {
    padding: 8px 16px;
    font-size: 0.9rem;
  }
}
</style>
